//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUser, getCollege } from "@/common/js/cache";
import { getHomeList } from "@/api/home";
import { mapGetters, mapActions } from 'vuex'
import { childWebsite } from "@/common/js/config";
// import Vconsole from 'vconsole'


export default {
  name: "app",
  data(){
    return {
      statis:'',
      classValue: '',
      classShoadowShow: true
    }
  },
  computed:{
    ...mapGetters(['college'])
  },
  created() {

    (function(doc, win) {
      var docEl = doc.documentElement,
        resizeEvt =
          "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function() {
          var clientWidth = docEl.clientWidth;
          if (!clientWidth) return;
          var val = Number(200 * (clientWidth / 750));
          docEl.style.fontSize = val > 200 ? "200px" : val + "px";
        };

      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
    })(document, window);


    // 刷新
    getUser();
    getCollege();

    if(this.college){
      this._contact(this.college)
      this.classValue = 'theme-color'+this.college.category_id
      this.classShoadowShow = false
    }else{

      //获取学院信息
      let data = {
        // url:'10.18.0.127:8080'
        // url:'http://ke.hbxdfxc.com'
        // url:"ke.xhce.cn",
        url: childWebsite  //window.location.host //

      };
      // 请求参数设置成form data 形式
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
      getHomeList(formData)
      .then(res => {
        if(res.success){
          let json = {...res.entity.college}
          json.id = res.entity.college.college_id;
          // json.id= 11
          json.subWebsiteProfileList = res.entity.subWebsiteProfileList
          json.websiteCourseList = res.entity.websiteCourseList
          this._contact(json)
          this.saveCollegeAction(json)

          this.classValue = 'theme-color'+json.category_id

          setTimeout(()=>{
            this.classShoadowShow = false
          },600)
        }

      })
    }


  // var a = new Vconsole()
  console.log('aa')
  },
  mounted(){
  },
  methods:{
    _contact(json){
        //title

        document.title = json.college_name?json.college_name:'';
        //加载统计
        // try {
        //   let statis = json.subWebsiteProfileList.filter(item=>item.type=='censusCode')[0].description
        //   let statis2 = JSON.parse(statis).censusCode.replace(/<script>|<\/script>/g,"");
        //   //console.log(statis2);
        //   eval(statis2)
        // } catch (error) {
        //   console.log(error);
        // }

        //聊天
        // try {
        //   json.subWebsiteProfileList.forEach(function(item){
        //       if(item.type == 'consultCode'){
        //           let consultCode = JSON.parse(item.description);
        //           //console.log(consultCode);
        //           let reg = /src="[^>]*?"/g
        //           let arrMatch = consultCode.consultCode.match(reg);
        //           localStorage.setItem("kefu", arrMatch)
        //           if(arrMatch.length == 0){return}
        //           let arrSplit =  arrMatch.map((item)=>{
        //               if(item.split('src="')[1].indexOf('""')){
        //                   return item.split('src="')[1].split('"')[0];
        //               }else{
        //                   return item.split('src="')[1];
        //               }

        //           })

        //           arrSplit.forEach((item)=>{
        //               let oScript = document.createElement('script');
        //               oScript.src = item;

        //               let oDiv = document.createElement('div');
        //               oDiv.id="contact-chat-box"

        //               document.getElementsByTagName('body')[0].appendChild(oDiv)
        //               document.querySelector('#contact-chat-box').append(oScript)
        //           });

        //           let newvalue = consultCode.consultCode.replace(/<script.*?><\/script>/g,"");
        //           let newvalue2 = newvalue.replace(/<script>|<\/script>/g,"");
        //           console.log(arrMatch,'---------')
        //           if(!arrMatch) {
        //             document.querySelector('.main-contact').style.display='none'
        //           }
        //           setTimeout(()=>{
        //             eval(newvalue2)

        //             document.querySelector('.main-contact').style.display='none'

        //           },800)

        //       }
        //   });
        // } catch (error) {
        //   console.log(error);
        // }

    },
    ...mapActions([
      'saveCollegeAction'
    ])
  }
};



// WEBPACK FOOTER //
// ./src/App.vue